export default {"src":"/_next/static/media/crypto_news.8d813c18.svg","height":40,"width":170,"blurWidth":0,"blurHeight":0};